import { render, staticRenderFns } from "./templateA.vue?vue&type=template&id=b3a9df72&scoped=true&"
import script from "./templateA.vue?vue&type=script&lang=js&"
export * from "./templateA.vue?vue&type=script&lang=js&"
import style0 from "./templateA.vue?vue&type=style&index=0&id=b3a9df72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a9df72",
  null
  
)

export default component.exports